export const positionData = [
    {
        'UID': '26e29300-b879-4609-92d2-00eaa5bb15b3',
        'x' : '32', 
        'y' : '97',
        'type' : 'male-pose'
    },
    {
        'UID': 'aeceddab-faec-4b5b-ad57-081aab467f08',
        'x' : '47', 
        'y' : '151',
        'type' : 'male-top'
    },
    {
        'UID': 'c2f670ed-859e-4de0-b0e5-8a877cc30d85',
        'x' : '34', 
        'y' : '147',
        'type' : 'male-top'
    },
    {
        'UID': '6fa924c3-0ecd-4578-9139-e2d4ca45ad3b',
        'x' : '69', 
        'y' : '273',
        'type' : 'male-pants'
    },
    {
        'UID': '17bcd41c-b170-4fbf-86a9-5e6ea3feb97e',
        'x' : '67', 
        'y' : '273',
        'type' : 'male-pants'
    },
    {
        'UID': '94e9dacf-a86f-4d87-a67b-a3d166703b1e',
        'x' : '87', 
        'y' : '110',
        'type' : 'male-face'
    },
    {
        'UID': 'f40966cf-2f5e-482e-b8f9-ccf31063fcf0',
        'x' : '87', 
        'y' : '110',
        'type' : 'male-face'
    },
    {
        'UID': 'd9a8eb2a-31a6-44b3-a338-4705c7c2e7d7',
        'x' : '87', 
        'y' : '110',
        'type' : 'male-face'
    },
    {
        'UID': '09a5e0fe-d38a-4b82-a4fd-0da9d6e1a9ea',
        'x' : '87', 
        'y' : '90',
        'type' : 'male-hair'
    },
    {
        'UID': 'eba271a0-0cac-435b-b9ba-d6ba502a7eef',
        'x' : '88', 
        'y' : '63',
        'type' : 'male-hair'
    },
    {
        'UID': 'b807a716-5c5a-40c1-8da2-421b9f2eb534',
        'x' : '87.8', 
        'y' : '91',
        'type' : 'male-hair'
    },
    /////
    {
        'UID': '4cef53c3-208f-4dc9-b2cd-1622e5129baf',
        'x' : '25', 
        'y' : '97',
        'type' : 'male-pose'
    },
    {
        'UID': '59aee77a-d526-4c4c-b81f-f41aea2bb03d',
        'x' : '27', 
        'y' : '143',
        'type' : 'male-top'
    },
    {
        'UID': '1126dc80-fbda-4a5c-b6a0-30d900bbbbcb',
        'x' : '40', 
        'y' : '148',
        'type' : 'male-top'
    },
    {
        'UID': '3dcb7dd1-89c5-4b10-b51b-0ed7c96f3a3e',
        'x' : '63', 
        'y' : '271',
        'type' : 'male-pants'
    },
    {
        'UID': 'b799a5b0-5829-4928-b39f-80f90c0eee43',
        'x' : '62', 
        'y' : '271',
        'type' : 'male-pants'
    },
    {
        'UID': '94e9dacf-a86f-4d87-a67b-a3d166703b1h',
        'x' : '82', 
        'y' : '111',
        'type' : 'male-face'
    },
    {
        'UID': 'f40966cf-2f5e-482e-b8f9-ccf31063fcf7',
        'x' : '82', 
        'y' : '111',
        'type' : 'male-face'
    },
    {
        'UID': 'd9a8eb2a-31a6-44b3-a338-4705c7c2e7d8',
        'x' : '82', 
        'y' : '111',
        'type' : 'male-face'
    },
    {
        'UID': '09a5e0fe-d38a-4b82-a4fd-0da9d6e1a9ej',
        'x' : '80.5', 
        'y' : '89',
        'type' : 'male-hair'
    },
    {
        'UID': 'eba271a0-0cac-435b-b9ba-d6ba502a7eet',
        'x' : '80.8', 
        'y' : '62.9',
        'type' : 'male-hair'
    },
    {
        'UID': 'b807a716-5c5a-40c1-8da2-421b9f2eb538',
        'x' : '81', 
        'y' : '90',
        'type' : 'male-hair'
    },
    ///////
    {
        'UID': 'cdb58741-ca7d-4a03-bfe7-96974ab6e7de',
        'x' : '53', 
        'y' : '97',
        'type' : 'female-pose'
    },
    {
        'UID': 'cff63ad7-574c-4e0a-ba31-083edb1f9b2d',
        'x' : '74', 
        'y' : '151',
        'type' : 'female-top'
    },
    {
        'UID': '4fd5c3eb-63bd-489d-b643-e240072cc40e',
        'x' : '52', 
        'y' : '151',
        'type' : 'female-top'
    },
    {
        'UID': 'bac3bc02-6fec-4c34-8ba7-215ee5ee3c80',
        'x' : '62.5', 
        'y' : '229.5',
        'type' : 'female-pants'
    },
    {
        'UID': '2679a0f8-7032-4e75-87fe-c22b4b4a233d',
        'x' : '64', 
        'y' : '230',
        'type' : 'female-pants'
    },
    {
        'UID': '94e9dacf-a86f-4d87-a67b-a3d166703b1t',
        'x' : '75', 
        'y' : '110',
        'type' : 'female-face'
    },
    {
        'UID': 'f40966cf-2f5e-482e-b8f9-ccf31063fcf9',
        'x' : '75', 
        'y' : '110',
        'type' : 'female-face'
    },
    {
        'UID': 'd9a8eb2a-31a6-44b3-a338-4705c7c2e7d4',
        'x' : '75', 
        'y' : '110',
        'type' : 'female-face'
    },
    {
        'UID': '92802cb9-ccd2-4e6b-a846-dcb5ee0c3a5d',
        'x' : '73', 
        'y' : '88.7',
        'type' : 'female-hair'
    },
    {
        'UID': '5dc66fc9-9f00-4c0c-bdfe-350c0c471e6c',
        'x' : '72.5', 
        'y' : '88',
        'type' : 'female-hair'
    },
    {
        'UID': '2afecc48-1e4a-4aa1-af11-1412a9d29e85',
        'x' : '72', 
        'y' : '83.7',
        'type' : 'female-hair'
    },
    ///////
    {
        'UID': '28924882-d7ad-4f36-a1d3-539e5e404468',
        'x' : '35', 
        'y' : '97',
        'type' : 'female-pose'
    },
    {
        'UID': '6f32c03e-eca5-4771-bf07-5ee965b6aab9',
        'x' : '70', 
        'y' : '151',
        'type' : 'female-top'
    },
    {
        'UID': 'd0b63793-6bea-4b0c-b99d-6dac6a232825',
        'x' : '38', 
        'y' : '151',
        'type' : 'female-top'
    },
    {
        'UID': '55d2e668-51bb-4b0b-9e68-1f0137dcb63d',
        'x' : '63', 
        'y' : '229',
        'type' : 'female-pants'
    },
    {
        'UID': '3671c518-3f71-4e05-acc3-bf1fd5322a16',
        'x' : '64', 
        'y' : '229.5',
        'type' : 'female-pants'
    },
    {
        'UID': '94e9dacf-a86f-4d87-a67b-a3d166703b1t',
        'x' : '75', 
        'y' : '110',
        'type' : 'female-face'
    },
    {
        'UID': 'f40966cf-2f5e-482e-b8f9-ccf31063fcf9',
        'x' : '75', 
        'y' : '110',
        'type' : 'female-face'
    },
    {
        'UID': 'd9a8eb2a-31a6-44b3-a338-4705c7c2e7d4',
        'x' : '75', 
        'y' : '110',
        'type' : 'female-face'
    },
    {
        'UID': '92802cb9-ccd2-4e6b-a846-dcb5ee0c3a5d',
        'x' : '74', 
        'y' : '88.4',
        'type' : 'female-hair'
    },
    {
        'UID': '5dc66fc9-9f00-4c0c-bdfe-350c0c471e6c',
        'x' : '74', 
        'y' : '88',
        'type' : 'female-hair'
    },
    {
        'UID': '2afecc48-1e4a-4aa1-af11-1412a9d29e85',
        'x' : '73.3', 
        'y' : '83',
        'type' : 'female-hair'
    },

]